import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, of, switchMap } from 'rxjs';

import { EffectsBase } from '@ps/core-data-access';

import { OperatorCompaniesService } from '../../../services/operator-companies.service';
import { OperatorCompaniesActions } from '../actions/operator-companies.actions';

@Injectable()
export class OperatorCompaniesEffects extends EffectsBase {
  private readonly _actions$ = inject(Actions);
  private readonly _service = inject(OperatorCompaniesService);

  public readonly loadCompanies$ = createEffect(() =>
    this._actions$.pipe(
      ofType(OperatorCompaniesActions.loadCompanies),
      switchMap(() =>
        this._service.getCompanies().pipe(
          map((companies) =>
            OperatorCompaniesActions.loadCompaniesSuccess({ companies }),
          ),
          this.psCatchError(
            (error) =>
              of(
                OperatorCompaniesActions.loadCompaniesFailure({
                  error: error.message,
                }),
              ),
            { notify: true },
          ),
        ),
      ),
    ),
  );
}
